module.exports = __webpack_public_path__ + "img/app-store.f9f45cfa.png";